export default __webpack_public_path__ + "static/media/portfolio-cerini-3.ab7d4965.jpg";